import React from 'react'
import styled from 'styled-components'

import Textarea from 'components/Textarea'
import TextInput from 'components/TextInput'
import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

import { shortDate } from 'helpers/formatters'
import { scrubText } from 'helpers/inputCleaners'

type ErrorProps = {
  internalName: string
  title: string
  message: string
  brands: string
  roles: string
}

type Props = {
  published: boolean
  publishedAt: string
  expired: boolean
  expiredAt: string
  onChangeCallback: (object)=> void
  title: string
  internalName: string
  message: string
  errors: ErrorProps
}

const FeatureTourFields = ({ internalName, title, message, published, publishedAt, expired, expiredAt, onChangeCallback, errors }: Props) => {
  return (
    <>
      <S.FormSection title="Published">
        <Checkbox
        label={`Published ${publishedAt ? ` (${shortDate(publishedAt)})` : ''}`}
        checked={published}
        onChange={() => onChangeCallback({ published: !published })}
        />

        <Checkbox
        label={`Expired ${expiredAt ? ` (${shortDate(expiredAt)})` : ''}`}
        checked={expired}
        onChange={() => onChangeCallback({ expired: !expired })}
        />
      </S.FormSection>
      <br />
      <S.TextInput
        label="Internal Name"
        isRequired
        onChange={event => onChangeCallback({ internalName: scrubText(event.target.value, true) })}
        value={internalName || ''}
        errorMessage={errors.internalName}
      />

      <S.TextInput
        label="Title"
        isRequired
        onChange={event => onChangeCallback({ title: scrubText(event.target.value, true) })}
        value={title || ''}
        errorMessage={errors.title}
      />

      <Textarea
        label="Message"
        isRequired
        rows={10}
        onChange={event => onChangeCallback({ message: scrubText(event.target.value, true) })}
        value={message || ''}
        errorMessage={errors.message}
      />
    </>
  )
}

const S = {
  FormSection: styled(FormSection)`
    margin-bottom: 10px;
  `,
  TextInput: styled(TextInput)`
    padding-bottom: 10px;
  `
}

export default FeatureTourFields
